import React from 'react';
import {Typography} from "@mui/material";
import clsx from "clsx";

export default function Title(props) {
    return (
        <Typography
            ref={props.ref}
            style={props.style}
            component={!!props.component ? props.component : "h2"}
            variant="h6"
            to={props.to}
            className={clsx("heading",props.className)}
            color={props.color ? props.color : "primary"}
            align={props.align ? props.align : "center"}

            gutterBottom
        >
            {props.children}
        </Typography>
    );
}
